import ResourceRequestDrawer from './ResourceRequestDrawer';

const resourceRequestDrawerRoute = {
  path: '#/resourceRequest/:id',
  component: ResourceRequestDrawer
};

export default resourceRequestDrawerRoute;
